//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StateComponent from '@/components/StateComponent';
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';

// Sitio de evaluacion de desempeno y audiencia acordada con ese equipo
var EVALUATION_URL = process.env.VUE_APP_EVALUATION_URL || '';
var AUDIENCE = process.env.VUE_APP_EVALUATION_AUDIENCE || 'mdy-data-performance';

// El sitio destino arranca un temporizador de ~1.5s en cuanto monta su React y,
// si no recibio la sesion para entonces, la da por fallida. El evento load del
// iframe llega mucho despues (espera bundle, CSS y fuentes), asi que enviar solo
// en load llega tarde. Y postMessage no se encola: si no hay listener en ese
// instante, el mensaje se pierde sin error.
// Por eso se emite de forma periodica desde que el iframe esta en el DOM: alguno
// de los envios cae en la ventana util. Su app ignora los repetidos una vez que
// tomo la sesion.
var SEND_INTERVAL_MS = 200;
var SEND_WINDOW_MS = 6000;
export default {
  name: 'EvaluationPage',
  components: {
    StateComponent: StateComponent
  },
  data: function data() {
    return {
      evaluationUrl: EVALUATION_URL,
      audience: AUDIENCE,
      loading: true,
      keyFrame: 1,
      frameHeight: 600,
      token: null,
      lastSentType: null,
      sendCount: 0,
      refreshCount: 0
    };
  },
  computed: {
    isLocalEnv: function isLocalEnv() {
      return process.env.VUE_APP_ENV === 'local' || process.env.NODE_ENV === 'development';
    },
    // El destino compara este valor contra su allowlist, caracter por caracter:
    // 127.0.0.1 y localhost no son equivalentes para esa validacion
    ourOrigin: function ourOrigin() {
      return window.location.origin;
    },
    // Origin del sitio destino: para dirigir el postMessage y para validar el
    // origen de los mensajes que llegan de vuelta
    targetOrigin: function targetOrigin() {
      try {
        return new URL(EVALUATION_URL).origin;
      } catch (e) {
        return null;
      }
    },
    canRenderFrame: function canRenderFrame() {
      return !!EVALUATION_URL && !!this.token;
    },
    errorTitle: function errorTitle() {
      return EVALUATION_URL ? this.$t('performance_evaluation.token_error') : this.$t('performance_evaluation.not_configured');
    },
    errorDetail: function errorDetail() {
      return EVALUATION_URL ? this.$t('performance_evaluation.token_error_detail') : this.$t('performance_evaluation.not_configured_detail');
    }
  },
  watch: {
    // Arranca la emision apenas el iframe esta en el DOM, sin esperar al load
    canRenderFrame: function canRenderFrame(ready) {
      if (ready) this.$nextTick(this.startSending);
    }
  },
  created: function created() {
    // No reactivos: solo ids de timers
    this._sendInterval = null;
    this._sendStop = null;
    if (!EVALUATION_URL) {
      this.loading = false;
      return;
    }
    this.requestToken();
  },
  mounted: function mounted() {
    this.updateFrameHeight();
    window.addEventListener('resize', this.updateFrameHeight);
    window.addEventListener('message', this.onChildMessage);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.updateFrameHeight);
    window.removeEventListener('message', this.onChildMessage);
    this.clearSendTimers();
  },
  methods: {
    updateFrameHeight: function updateFrameHeight() {
      // Alto util de la ventana descontando cabecera, titulo y margenes
      var height = window.innerHeight - 260;
      this.frameHeight = height > 400 ? height : 400;
    },
    // El token se pide antes de montar el iframe para poder enviarlo apenas
    // cargue, dentro de la ventana que el sitio destino tolera
    requestToken: function requestToken() {
      var _this = this;
      this.loading = true;
      return UserSecurityService.getIframeToken(this.audience).then(function (response) {
        var token = response && response.data && response.data.token;
        if (!token) throw new Error('respuesta sin token');
        _this.token = token;
      }).catch(function () {
        _this.token = null;
      }).finally(function () {
        _this.loading = false;
      });
    },
    onFrameLoad: function onFrameLoad() {
      this.sendSession();
    },
    // Emision periodica mientras dura la ventana util del destino
    startSending: function startSending() {
      this.clearSendTimers();
      this.sendSession();
      this._sendInterval = window.setInterval(this.sendSession, SEND_INTERVAL_MS);
      this._sendStop = window.setTimeout(this.clearSendTimers, SEND_WINDOW_MS);
    },
    clearSendTimers: function clearSendTimers() {
      if (this._sendInterval) window.clearInterval(this._sendInterval);
      if (this._sendStop) window.clearTimeout(this._sendStop);
      this._sendInterval = null;
      this._sendStop = null;
    },
    // Mientras el iframe no ha navegado contiene about:blank, que hereda
    // nuestro origen: enviar ahi provoca un error de origen no coincidente.
    // Leer location.href solo funciona mientras compartimos origen; en cuanto
    // navega al sitio destino lanza SecurityError, y eso es justo la senal de
    // que ya se puede enviar.
    hasNavigated: function hasNavigated(frame) {
      try {
        var href = frame.contentWindow.location.href;
        return !!href && href !== 'about:blank';
      } catch (e) {
        return true;
      }
    },
    // Contrato del sitio destino: { type: 'AUTH_SESSION', token }
    sendSession: function sendSession() {
      if (!this.token || !this.targetOrigin) return;
      var frame = this.$refs.evaluationFrame;
      if (!frame || !frame.contentWindow) return;
      if (!this.hasNavigated(frame)) return;
      frame.contentWindow.postMessage({
        type: 'AUTH_SESSION',
        token: this.token
      }, this.targetOrigin);
      this.lastSentType = 'AUTH_SESSION';
      this.sendCount += 1;
    },
    // El sitio destino avisa con AUTH_EXPIRED cuando su API responde 401
    onChildMessage: function onChildMessage(event) {
      var _this2 = this;
      if (!this.targetOrigin || event.origin !== this.targetOrigin) return;
      if (!event.data || event.data.type !== 'AUTH_EXPIRED') return;
      this.refreshCount += 1;
      this.requestToken().then(function () {
        return _this2.sendSession();
      });
    },
    // Para el panel local: no imprimir el token completo
    resumenToken: function resumenToken(token) {
      if (!token) return '—';
      return token.slice(0, 12) + '…' + token.slice(-6) + ' (' + token.length + ' chars)';
    },
    onReload: function onReload() {
      var _this3 = this;
      this.clearSendTimers();
      this.token = null;
      this.lastSentType = null;
      this.sendCount = 0;
      this.requestToken().then(function () {
        _this3.keyFrame += 1;
      });
    }
  }
};